export default __webpack_public_path__ + "static/media/comment.87450cb6.svg";